import { Badge } from '@/components/ui/badge';
import type { VacancyPriority } from '@/types/recruitment';

const PRIORITY_CONFIG: Record<VacancyPriority, { label: string; variant: 'default' | 'secondary' | 'success' | 'warning' | 'destructive' | 'outline' | 'info' }> = {
  LOW: { label: 'Low', variant: 'secondary' },
  MEDIUM: { label: 'Medium', variant: 'info' },
  HIGH: { label: 'High', variant: 'warning' },
  CRITICAL: { label: 'Critical', variant: 'destructive' },
};

export function VacancyPriorityBadge({ priority }: { priority: VacancyPriority }) {
  const config = PRIORITY_CONFIG[priority];
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
